import { message, Upload } from 'antd';
import React from 'react';

import '~/shared/components/form-fields/drop-zone-field/drop-zone-field.scss';

const { Dragger } = Upload;

type DropZoneFieldPropsType = {
  t: (key: string, options: { ns: string[] }) => string;
};

const DropZoneField = ({ t, value, name, setValue, onChange, config }: DropZoneFieldPropsType) => {
  return (
    <div className="drop-zone-field">
      <Dragger
        {...{
          name: 'file',
          multiple: config?.isMultiple ?? true,
          action: 'https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188',
          onChange(info) {
            const { status } = info.file;

            if (status === 'done') {
              message.success(`${info.file.name} file uploaded successfully.`);
              setValue(
                name,
                info.fileList?.map((item) => {
                  return item?.name;
                }),
                { shouldValidate: false },
              );
            } else if (status === 'error') {
              message.error(`${info.file.name} file upload failed.`);
            }
          },
        }}
      >
        <p className="drop-zone-field__placeholder">Click or drag file to this area to upload</p>
      </Dragger>
    </div>
  );
};

export default DropZoneField;
